<template>
    <div :class="class">
        <LottieAnimation class="lottie-wrapper"
            :animation-data="require('@/assets/lottie/' + jsonFile)"
            :auto-play="autoPlay"
            :loop="loop"
            :speed="speed"
            @animCreated="handleAnimCreated"
            ref="anim" />
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
    import { ref, onBeforeUnmount } from "vue";
    import { LottieAnimation } from "lottie-web-vue"

    const props = defineProps({
        class: {type: String},
        jsonFile: {type: String},
        autoPlay: {type: Boolean, default: true},
        loop: {type: Boolean, default: true},
        speed: {type: Number, default: 1}
    })

    const emit = defineEmits(['on-complete']);

    const animInstance = ref(null);

    function handleAnimCreated(anim: any) {
      animInstance.value = anim;
      anim.addEventListener('complete', onCompleteHandler);
    }

    function onCompleteHandler() {
      if (!props.loop) {
        emit('on-complete');
      }
    }
    
    onBeforeUnmount(() => {
      if (animInstance.value) {
        animInstance.value.removeEventListener('complete', onCompleteHandler);
      }
    });
</script>